"use client";
import React from "react";
import { CarouselProps } from "@/interface";
import { ContextProps, useGlobalContext } from "@/contexts/AppContext";
import Image from "next/image";
import styles from "./Carousel.module.scss";

const Carousel = ({
	title,
	icon1,
	icon2,
	bgColor,
	isBorder = false,
	type = "small",
}: CarouselProps) => {
	const { theme }: ContextProps = useGlobalContext();
	const isSmall = title.length <= 5;
	const isMedium = title.length > 5 && title.length < 11;
	const isLong = title.length >= 14;
	return (
		<div
			className={styles.container}
			data-small={isSmall}
			data-medium={isMedium}
			data-type={type}
			data-isborder={isBorder}
			data-theme={theme}
			data-long={isLong}
			style={{ background: `${bgColor}` }}
		>
			{isSmall ? (
				[1, 2, 3, 4].map((item: any, index: number) => (
					<div key={index} className={`${styles.row}`}>
						<div className={styles.icon}>
							<Image src={icon1} fill alt="" />
						</div>
						<div className={styles.text}>
							<h1>{title}</h1>
						</div>
						<div className={styles.icon}>
							<Image src={icon2} fill alt="" />
						</div>
						<div className={styles.text}>
							<h1>{title}</h1>
						</div>
					</div>
				))
			) : (
				<>
					{isMedium
						? [1, 2, 3, 4].map((item: any, index: number) => (
								<div key={index} className={`${styles.row}`}>
									<div className={styles.icon}>
										<Image src={icon1} fill alt="" />
									</div>
									<div className={styles.text}>
										<h1>{title}</h1>
									</div>
									<div className={styles.icon}>
										<Image src={icon2} fill alt="" />
									</div>
									<div className={styles.text}>
										<h1>{title}</h1>
									</div>
								</div>
						  ))
						: [1, 2].map((item: any, index: number) => (
								<div key={index} className={`${styles.row}`}>
									<div className={styles.icon}>
										<Image src={icon1} fill alt="" />
									</div>
									<div className={styles.text}>
										<h1>{title}</h1>
									</div>
									<div className={styles.icon}>
										<Image src={icon2} fill alt="" />
									</div>
									<div className={styles.text}>
										<h1>{title}</h1>
									</div>
								</div>
						  ))}
				</>
			)}
			{/* <div className={`${styles.row}`}>
				<div className={styles.icon}>
					<Image src={icon1} fill alt='' />
				</div>
				<div className={styles.text}>
					<h1>{title}</h1>
				</div>
				<div className={styles.icon}>
					<Image src={icon2} fill alt='' />
				</div>
				<div className={styles.text}>
					<h1>{title}</h1>
				</div>
				<div className={styles.icon}>
					<Image src={icon1} fill alt='' />
				</div>
				<div className={styles.text}>
					<h1>{title}</h1>
				</div>
				<div className={styles.icon}>
					<Image src={icon2} fill alt='' />
				</div>
				<div className={styles.text}>
					<h1>{title}</h1>
				</div>
			</div> */}
		</div>
	);
};

export default Carousel;
